// Mutation hook - dodanie kontaktu do transakcji
// POST /api/ui/sales-crm/deals/{id}/contacts

import { axios } from 'api';
import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';
import type { IPostDealContactRequest } from 'api/types/deals';

interface IPostDealContactResponse {
  data?: { id?: number };
  message?: string;
  status?: string;
}

interface IPostDealContactVariables {
  dealId: number;
  body: IPostDealContactRequest;
}

const postDealContact = ({
  dealId,
  body,
}: IPostDealContactVariables): Promise<IPostDealContactResponse> =>
  axios.post(`/sales-crm/deals/${dealId}/contacts`, body);

export const usePostDealContact = (
  options?: UseMutationOptions<IPostDealContactResponse, IError, IPostDealContactVariables>,
) => {
  const queryClient = useQueryClient();
  return useMutation<IPostDealContactResponse, IError, IPostDealContactVariables>(
    postDealContact,
    {
      ...options,
      onSuccess: async (data, variables, context) => {
        await queryClient.invalidateQueries(['sales-crm-deal-contacts', variables.dealId]);
        await queryClient.refetchQueries(['sales-crm-deal-contacts', variables.dealId]);
        options?.onSuccess?.(data, variables, context);
      },
    },
  );
};
